/*
 * quantityForecasts reducer
 */
// Constants
import get from 'lodash.get';
import { RESET_STATE } from '../auth/constants';
import {
    QUANTITY_FORECASTS_SET,
    QUANTITY_FORECASTS_MERGE,
    QUANTITY_FORECAST_SET
} from './constants';

const initialState = {};

type State = {};

type Action = {
    +type: string,
    +payload: any
};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case QUANTITY_FORECASTS_SET: {
            return action.payload;
        }
        case QUANTITY_FORECASTS_MERGE: {
            const quantityForecasts = get(
                action,
                'payload.entities.quantityForecasts',
                {}
            );
            return {
                ...state,
                ...quantityForecasts
            };
        }
        case QUANTITY_FORECAST_SET: {
            const quantityForecasts = get(
                action,
                'payload.entities.quantityForecasts',
                {}
            );
            return {
                ...state,
                ...quantityForecasts
            };
        }
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
